import React from 'react';
import { Tooltip } from '@umu/umu-design';
const defaultMax = 10;

const renderTooltip = (text: string) => {
    const isShowTips = (text || '').length > defaultMax;
    return (
        <Tooltip title={isShowTips ? text : ''} placement="bottom" zIndex={9000}>
            <div className="template-row-1">{text}</div>
        </Tooltip>
    );
};
export { renderTooltip };
